import { Checkbox } from "@mantine/core";
import CheckboxSurvey from "../../../components/form/Checkbox";
import { useTranslation } from "react-i18next";

type Props = {
  form: any;
};

const Component = ({ form }: Props) => {
  const { t } = useTranslation();

  return (
    <CheckboxSurvey
      label={t("witnessActionsQuestions.label")}
      {...form.getInputProps("ACT_001_008")}
    >
      <Checkbox
        label="Generé una distracción (por ejemplo, cambié el tema de conversación)."
        value="ACT_001"
      />
      <Checkbox
        label="Confronté a la persona que estaba haciendo estas conductas."
        value="ACT_002"
      />
      <Checkbox
        label="Informé de lo sucedido en el canal ético, recursos humanos o mi jefe/a."
        value="ACT_003"
      />
      <Checkbox
        label="En ese momento no intervine pero luego me acerqué a la persona para ver cómo estaba."
        value="ACT_004"
      />
      <Checkbox
        label="En ese momento no intervine pero luego me acerqué a quien incurrió en el comportamiento."
        value="ACT_005"
      />
      <Checkbox
        label="No intervine porque no supe qué hacer en ese momento."
        value="ACT_006"
      />
      <Checkbox label="No me pareció necesario intervenir." value="ACT_008" />
    </CheckboxSurvey>
  );
};

export default Component;
